import { toast, useSonner } from "sonner";
import { X } from "lucide-react";

export default function ToastClearAll() {
  const { toasts } = useSonner();
  if (toasts.length < 2) return null;
  return (
    <button
      data-testid="toast-clear-all"
      onClick={() => toast.dismiss()}
      className="fixed top-1.5 right-8 z-[2147483647] inline-flex items-center gap-1.5 bg-gray-900/90 hover:bg-gray-900 text-white text-xs font-semibold rounded-full pl-2.5 pr-3 py-1.5 shadow-lg backdrop-blur transition-colors"
    >
      <X size={12} /> Clear all ({toasts.length})
    </button>
  );
}
